const env = process.env.NODE_ENV || 'development'

// 政企实训后端服务地址（网关前缀 /ajtools，端口 19091）
const config = {
  development: {
    baseURL: 'http://192.168.11.103:19091/ajtools'
    // baseURL: 'https://train.aojuai.com/ajtools'
  },
  production: {
    baseURL: 'https://train.aojuai.com/ajtools'
  }
}
export default config[env] || config.development
